<template>
	<v-card outlined>
		<v-card-title
			class = "justify-center info pa-0 body-1 primary white--text"
		>
			<span>
				{{ $ml.get('timezone') }}
			</span>
			
		</v-card-title>
		<v-card-text
			class = "pa-1 pt-2"
		>
			<v-row>
				<template v-for = "(item_info, idx_info) of info_fields">
					
					<v-col
						:md  = "6"
						:key = "idx_info"
					>
						<v-text-field
							dense
							outlined
							hide-details
							v-show 	  = "item_info.enable"
							:type 	  = "item_info.type"
							v-model   = "info[item_info.key]"
							:label 	  = "$ml.get(item_info.text)"
							:disabled = "item_info.is_disabled"
						></v-text-field>

						<v-select
							v-show 		= "item_info.type == 'select'"
							hide-details
							outlined
							dense
							:items 		= "render_list_filter"
							text-value  = "name"
							:label 		= "$ml.get(item_info.text)"
							v-model 	= "info[item_info.key]"
						>
							<template v-slot:selection="{ item }">
								<span>{{ item }}</span>
								<span class="grey--text text--lighten-1 ml-2">(UTC{{ get_offset(item) }})</span>
							</template>
							<template v-slot:item="{ item }">
								<v-list-item-content>
									<v-list-item-title>
										{{ item }}
										<span class="grey--text text--lighten-1 ml-2">UTC{{ get_offset(item) }}</span>
									</v-list-item-title>
								</v-list-item-content>
							</template>
							<template v-slot:prepend-item>
				          	<v-list-item>
				            	<v-list-item-content
				            		@click = "$Helper.keyboard_is_active('search', ID_notification, 'text')"
				            	>


							        <v-text-field
							        	dense
							        	outlined
							        	hide-details
							        	v-model 	 = "search"
							        	label		 = "Search"
							        	class		 = "mx-4 pt-1"
							        	append-icon  = "mdi-magnify"
							        	@input 		 = "v => {filter_search(v)}"
							        ></v-text-field>
							        	<!-- , filter_search(search) -->
							        	<!-- @keyup.enter = "get_search(selected_tags)" -->
							        	<!-- @click 		 = "keyboard_is_active()" -->
								</v-list-item-content>
					          </v-list-item>
					          <v-divider class="mt-1"></v-divider>
					        </template>
						</v-select>

					</v-col>
				</template>
			</v-row>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-progress-linear
		      	indeterminate
		      	v-show = "loading"
		      	color  = "primary"
		    ></v-progress-linear>
			<v-btn
				x-small
		      	v-show = "!loading"				
				@click = "save"
				color  = "primary"
				v-text = "$ml.get('save')"
			></v-btn>

			<v-spacer></v-spacer>
			
			<v-btn
				x-small
		      	v-show = "!loading"				
				@click = "reset"
				color  = "error"
				v-text = "$ml.get('reset')"
			></v-btn>
			
		</v-card-actions>
	</v-card>
</template>
<script>
	import EventBus from '@/event-bus'
	export default {
		name 	: "time_zone",
		props 	: [ 'info_module' ],
		data 	: (vm) => ({
			info 		: {
				timezone 			: '',
				suggested_timezone  : '',
			},			
			info_fields : [
				{
					key  : 'timezone',
					type : 'select',
					text : 'select_timezone',
					list : 'list_filter',
				},
				{
					key  : 'suggested_timezone',
					text : 'suggested_timezone',
					type : 'text',
					enable 		: true,
					is_disabled : true,

					
				},

			],
			search 			: '',
			list_zones  	: vm.$momentz.tz.names().filter(z => vm.$momentz.tz.zone(z).name === z),
			list_filter 	: [],
			ID_notification : 'TimeZone',
			loading 		: false,
			bus 			: {},
		}), // data
		
		created(){
			this.get_list();
			
			
			

		}, // created
		
		methods:{
			actions(act, item, opt){
				if (act == 'confirm_reset') {
					EventBus.$emit('notifications_modal', {
						type : 'confirm_reset',
						ID   : this.ID_notification
					});
				}
			}, // actions

			get_list(){
				let time_zone = ``;
				const api 		= this.$URL + '/api/v1/parameter/' + 1;
				const api1   	= this.$URL + '/api/v1/parameter';
				this.loading 	= true;
				
				let guess_temp  = this.$momentz.tz.guess();

				this.$axios.get(api).then( res => {
					this.loading = false;
					if (res && res.data) {
						this.info = res.data;
						this.info.suggested_timezone  = guess_temp;
						if (this.info.timezone && !this.list_zones.includes(this.info.timezone)) {
							this.list_zones.push(this.info.timezone);
						}

					}else{
						let info_up = {
							timelapse      	: 20,
							timeoutAlert  	: 5,
							timezone 		: this.$timezone,

						}
						this.$axios.post(api1, info_up).then(ress =>{
							if (ress && ress.data) {
								this.info = info_up;	
								this.info.suggested_timezone  = guess_temp;							
							}
						}).catch(err => {
							console.log("error create timezone ", err);
							this.$EventBus.$emit('notifications_modal',{
								type 	: 'error',
								message : err 
							});			

						})
						console.log("Not found info timezone", res);
					}
				}).catch( er => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : er
					});
					this.get_local();
					this.info.suggested_timezone  = guess_temp;							

				});
				

			}, // get_list
			get_local(){
				if (localStorage.getItem('time_zone')) {
					let time_zone = JSON.parse(localStorage.getItem('time_zone'));
					this.info.timezone = time_zone;
				}else{
					this.info.timezone = this.$timezone;
				}
			}, // get local

			save(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_edit", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				const info_up 	= this.info;
				this.$timezone 	= info_up.timezone;
				const api 		= this.$URL + '/api/v1/parameter/' + 1;
				
				this.loading = true;
				this.$axios.put(api, info_up).then( res => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type : ''
					});
					this.$momentz.tz.setDefault(info_up.timezone);
					localStorage.setItem('time_zone', JSON.stringify(info_up.timezone));
					this.$EventBus.$emit('notifications_modal', {
						type : 'updated',
					});
					if(location.hostname == `.` || location.hostname == `chromewebdata` || location.localhost == `.`){ // localhost
	       				console.log("main reload", location.localhost)
	       				mainWindow.reload();

	       			}else {
	       				location.reload(); 
	       			}
				}).catch( er => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : er
					});
				});
			}, // save

			reset(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_delete", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				this.info.timezone = '';
				this.info.timezone = this.$momentz.tz.guess();
				this.save();
				if (localStorage.getItem('time_zone')) {
					localStorage.removeItem('time_zone');
				}
				this.$EventBus.$emit('notifications_modal', {
					type 	: 'deleted',
					message : ' ' + this.$ml.get('and_reseted')
				})

			}, // reset

			filter_search(val){
				let list = [];
		    	let vn   = this;
		    	let needle = (val || '').toLowerCase().replace(/\s+/g, '');

		    	list 	 = vn.list_zones.filter( filter_zone => {
		    		if (!filter_zone) return false;
		    		if (filter_zone.toLowerCase().indexOf(needle) > -1) return true;
		    		let off = vn.get_offset(filter_zone).toLowerCase();
		    		return off.indexOf(needle) > -1 || off.replace(':', '').indexOf(needle) > -1;
		    	})
		    	this.list_filter = list;
			}, // filter search

			get_offset(zone){
				if (!zone) return '';
				try {
					return this.$momentz.tz(zone).format('Z');
				} catch (e) {
					return '';
				}
			}, // get_offset
			
			render_list_sel(val){
				return this[val];

			}, // render_list_sel


		}, // methods

		computed :{
			render_list_filter(){
				// this.filter_search('');
				return this.list_filter && this.list_filter.length > 0 ? this.list_filter : this.list_zones ;
			}
		}, // computed

		mounted(){
			// console.log(, "TIMEZ *****************************************+");
			let temp_bus = 'keyboard_type' + this.ID_notification;
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					console.log("INPUT TYPE : ",action.input)
					if (action.setting) {
						let { obj, key, type } =  action.setting;
						if (type == 'text') {
							this[key] = action.input;
						}else{
							this[obj][key] = action.input;
						}
					}
				}
			});

			temp_bus = 'notifications_modal' + this.ID_notification;
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) => {
				if (action) {
					this.reset();
				}
			});
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(EventBus, this.bus, 'timezone');
			
		}, // beforeDestroy

	};
</script>